/**
 * propuesta-entidad — lógica pura del bloque Confirmar/Descartar (MP5-FRONT-CONFIRMAR,
 * 96b62f45). Sin dependencias de React/DOM: la tarjeta la consume, el test la cubre
 * (el repo testea lógica pura en lib/, no render — el render se valida en el e2e MP5-5).
 */

/**
 * Compone el body del POST DESCARTAR. Los campos_requeridos que exige el back (DMN
 * validar_descarte_borrador, p.ej. razon_descarte) van DENTRO de `payload`, no en el body
 * plano — y preservando cualquier payload que el back ya hubiera puesto en la acción.
 * Devuelve el primer campo faltante si alguno viene vacío/espacios.
 */
export function componerBodyDescarte(
  accionBody: Record<string, unknown>,
  camposRequeridos: string[],
  valores: Record<string, string>,
): { ok: true; body: Record<string, unknown> } | { ok: false; faltante: string } {
  if (!camposRequeridos.length) return { ok: true, body: accionBody }
  const payload: Record<string, string> = {}
  for (const c of camposRequeridos) {
    const v = (valores[c] || '').trim()
    if (!v) return { ok: false, faltante: c }
    payload[c] = v
  }
  return { ok: true, body: { ...accionBody, payload: { ...(accionBody.payload as object | undefined), ...payload } } }
}
